module.exports = __webpack_public_path__ + "img/0Q3B5795_Source.c1b1c13f.webp";